import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Avatar,
  Button,
  Paper,
  Container,
  Tabs,
  Tab,
  Card,
  CardContent,
} from '@mui/material';
import {
  Person as PersonIcon,
  Edit as EditIcon,
  Bookmark as BookmarkIcon,
  Article as ArticleIcon,
} from '@mui/icons-material';
import { getUserFromStorage, getLocationOn, uppercaseFirstLetter, Colors } from '../../../helpers/navigationHelpers';
import styles from './Profile.module.css';

const Profile = () => {
  const [user, setUser] = useState(null);
  const [locationOn, setLocationOn] = useState(false);
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    setUser(getUserFromStorage());
    setLocationOn(getLocationOn());
  }, []);

  const primaryColor = locationOn ? Colors.CUSTOM_YELLOW : Colors.PRIMARY;

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Container maxWidth="md" className={styles.container}>
      {/* Profile Header */}
      <Paper elevation={2} className={styles.profileHeader}>
        <Box className={styles.coverSection} sx={{ backgroundColor: primaryColor }}>
          {/* Cover gradient */}
        </Box>
        
        <Box className={styles.profileInfo}>
          <Avatar
            src={user?.pictureURL}
            alt={user?.username}
            sx={{
              width: 120,
              height: 120,
              border: '4px solid white',
              marginTop: '-60px',
              backgroundColor: primaryColor,
              fontSize: 48,
            }}
          >
            {!user?.pictureURL && user?.username?.charAt(0).toUpperCase()}
          </Avatar>
          
          <Typography variant="h4" component="h1" className={styles.username}>
            {uppercaseFirstLetter(user?.username || 'User')}
          </Typography>
          
          {user?.major && (
            <Typography variant="body1" color="text.secondary" gutterBottom>
              {user.major}
            </Typography>
          )}
          
          {user?.email && (
            <Typography variant="body2" color="text.secondary" gutterBottom>
              {user.email}
            </Typography>
          )}

          <Box className={styles.actionButtons}>
            <Button
              variant="contained"
              startIcon={<EditIcon />}
              sx={{
                backgroundColor: primaryColor,
                '&:hover': {
                  backgroundColor: primaryColor,
                  opacity: 0.8,
                },
              }}
            >
              Edit Profile
            </Button>
            <Button
              variant="outlined"
              startIcon={<PersonIcon />}
              sx={{
                borderColor: primaryColor,
                color: primaryColor,
                '&:hover': {
                  borderColor: primaryColor,
                  backgroundColor: 'rgba(0, 84, 153, 0.04)',
                },
              }}
            >
              Friends
            </Button>
          </Box>
        </Box>
      </Paper>

      {/* Tabs */}
      <Paper elevation={2} className={styles.tabsSection}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          centered
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: primaryColor,
            },
            '& .Mui-selected': {
              color: primaryColor + ' !important',
            },
          }}
        >
          <Tab icon={<ArticleIcon />} label="Posts" />
          <Tab icon={<BookmarkIcon />} label="Saved" />
        </Tabs>
      </Paper>

      {/* Tab Content */}
      <Box className={styles.tabContent}>
        {tabValue === 0 && (
          <Card>
            <CardContent>
              <Box className={styles.emptyState}>
                <ArticleIcon sx={{ fontSize: 64, color: '#ccc' }} />
                <Typography variant="h6" color="text.secondary" gutterBottom>
                  No posts yet
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Your posts will appear here
                </Typography>
              </Box>
            </CardContent>
          </Card>
        )}
        
        {tabValue === 1 && (
          <Card>
            <CardContent>
              <Box className={styles.emptyState}>
                <BookmarkIcon sx={{ fontSize: 64, color: '#ccc' }} />
                <Typography variant="h6" color="text.secondary" gutterBottom>
                  No saved items
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Save posts to view them later
                </Typography>
              </Box>
            </CardContent>
          </Card>
        )}
      </Box>
    </Container>
  );
};

export default Profile;

















